/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popAppcenterTipEnergy.vue?vue&type=template&id=4c66e712&scoped=true"
import script from "./popAppcenterTipEnergy.vue?vue&type=script&lang=js"
export * from "./popAppcenterTipEnergy.vue?vue&type=script&lang=js"
import style0 from "./popAppcenterTipEnergy.vue?vue&type=style&index=0&id=4c66e712&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c66e712",
  null
  
)

export default component.exports